export default {
  optOutHint: {
    title: 'Dotyczy wszystkich przyszłych wersji',
    availability: 'Qmulus nie będzie już otwierać nowości po aktualizacjach. Pozostają zawsze dostępne:',
    versionNumber: 'Numer wersji w menu użytkownika',
    showAgain: 'Aby znów pokazywać je po aktualizacjach, wybierz {location}.',
  },
};
